import { ReactiveController, ReactiveControllerHost, isServer } from "lit"

export class ResizeController implements ReactiveController {
  private observer?: ResizeObserver
  private hadFirstUpdate = false
  private borderBoxSize?: ResizeObserverSize

  constructor(
    host: ReactiveControllerHost,
    private target: () => HTMLElement
  ) {
    host.addController(this)

    if (!isServer) {
      this.observer = new ResizeObserver(([entry]) => {
        const [borderBoxSize] = entry.borderBoxSize
        this.borderBoxSize = borderBoxSize
        host.requestUpdate()
      })
    }
  }

  get inlineSize() {
    return this.borderBoxSize?.inlineSize
  }

  get blockSize() {
    return this.borderBoxSize?.blockSize
  }

  hostUpdated() {
    if (!this.hadFirstUpdate && this.observer) {
      this.observer.observe(this.target())
      this.hadFirstUpdate = true
    }
  }

  hostConnected() {
    // in case the host has rendered, disconnected, and is now reconnected
    if (this.hadFirstUpdate && this.observer) {
      this.observer.observe(this.target())
    }
  }

  hostDisconnected() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
